import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AccordionModule } from './accordion';
import { AlertModule } from './alert';
import { ButtonModule } from './button';
import { CalendarModule } from './calendar';
import { CardModule } from './card';
import { CarouselModule } from './carousel';
import { DatepickerModule } from './datepicker';
import { EaseModule } from './ease';
import { FilterModule } from './filter';
import { IconModule } from './icon';
import { ListModule } from './list';
import { LottieModule } from './lottie';
import { SearchBarModule } from './search-bar';
import { SlideToggleModule } from './slide-toggle';
import { SpinnerModule } from './spinner';
import { StickyFeedModule } from './sticky-feed';
import { TabsModule } from './tabs';
import { ProgressBarModule } from './progress-bar';
import { TabMenuModule } from './tab-menu';
import { StickyElementModule } from './sticky-element/sticky-element.module';
import { NoProductMessageModule } from './no-product-message/no-product-message.module';
import { WarningCardModule } from './warning-card/warning-card.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AccordionModule,
    AlertModule,
    ButtonModule,
    CalendarModule,
    CarouselModule,
    CardModule,
    DatepickerModule,
    EaseModule,
    FilterModule,
    IconModule,
    ListModule,
    LottieModule,
    SearchBarModule,
    SlideToggleModule,
    SpinnerModule,
    StickyFeedModule,
    TabsModule,
    ProgressBarModule,
    TabMenuModule,
    StickyElementModule,
    NoProductMessageModule,
    WarningCardModule,
  ],
  exports: [
    AccordionModule,
    AlertModule,
    ButtonModule,
    CalendarModule,
    CarouselModule,
    CardModule,
    DatepickerModule,
    EaseModule,
    FilterModule,
    IconModule,
    ListModule,
    LottieModule,
    SearchBarModule,
    SlideToggleModule,
    SpinnerModule,
    StickyFeedModule,
    TabsModule,
    ProgressBarModule,
    TabMenuModule,
    StickyElementModule,
    NoProductMessageModule,
    WarningCardModule,
  ],
})
export class MyvfUiModule {}
